var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPathway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.571,
    viewBox: "0 0 24 20.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-heartbeat",
    "data-name": "Icon metro-heartbeat",
    d: "M19.713,16.407H23.8a1.359,1.359,0,0,1-.134.141q-.067.06-.121.1l-.04.054L15.16,24.737a.841.841,0,0,1-1.179,0L5.624,16.675a1.265,1.265,0,0,1-.281-.268h4.942a.844.844,0,0,0,.529-.181.8.8,0,0,0,.3-.462L12.053,12,14.6,20.933a.854.854,0,0,0,.308.442.837.837,0,0,0,.522.174.817.817,0,0,0,.509-.174.854.854,0,0,0,.308-.442l1.955-6.5.75,1.5a.8.8,0,0,0,.763.469Zm6.857-5.732a7.281,7.281,0,0,1-1.379,4.018H20.249l-1.487-2.96a.808.808,0,0,0-.341-.362.853.853,0,0,0-1.239.509l-1.728,5.759L12.829,8.452a.841.841,0,0,0-.315-.442.865.865,0,0,0-.529-.174.837.837,0,0,0-.817.643L9.615,14.692H3.95a7.28,7.28,0,0,1-1.379-4.018,6.142,6.142,0,0,1,1.7-4.607,6.442,6.442,0,0,1,4.7-1.661,5.338,5.338,0,0,1,1.694.288,6.858,6.858,0,0,1,1.607.777q.743.489,1.279.917a12.351,12.351,0,0,1,1.018.911,12.336,12.336,0,0,1,1.018-.911q.536-.429,1.279-.917a6.856,6.856,0,0,1,1.607-.777,5.338,5.338,0,0,1,1.694-.288,6.442,6.442,0,0,1,4.7,1.661,6.142,6.142,0,0,1,1.7,4.607Z",
    transform: "translate(-2.571 -4.407)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPathway);
export default __webpack_public_path__ + "static/media/icon-pathway.421f8afd67b88ba81aa74e08a214d522.svg";
export { ForwardRef as ReactComponent };